import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const buyers = [{
  name: 'Juan',
  city: 'Ciudad de México',
  province: 'MX',
  initial: 'J',
  time: 'hace 2 min',
  pack: 'Pack Completo Listo Para Usar'
}, {
  name: 'María',
  city: 'Bogotá',
  province: 'CO',
  initial: 'M',
  time: 'hace 12 min',
  pack: 'Pack Completo Listo Para Usar'
}, {
  name: 'Carlos',
  city: 'Lima',
  province: 'PE',
  initial: 'C',
  time: 'hace 45 min',
  pack: 'Pack Completo Listo Para Usar'
}, {
  name: 'Laura',
  city: 'Santiago',
  province: 'CL',
  initial: 'L',
  time: 'hace 3 min',
  pack: 'Pack Completo Listo Para Usar'
}, {
  name: 'Roberto',
  city: 'Buenos Aires',
  province: 'AR',
  initial: 'R',
  time: 'hace 2 horas',
  pack: 'Pack Completo Listo Para Usar'
}, {
  name: 'Ana',
  city: 'Quito',
  province: 'EC',
  initial: 'A',
  time: 'hace 8 min',
  pack: 'Pack Completo Listo Para Usar'
}, {
  name: 'Diego',
  city: 'Montevideo',
  province: 'UY',
  initial: 'D',
  time: 'hace 22 min',
  pack: 'Pack Completo Listo Para Usar'
}, {
  name: 'Elena',
  city: 'Asunción',
  province: 'PY',
  initial: 'E',
  time: 'hace 45 seg',
  pack: 'Pack Completo Listo Para Usar'
}, {
  name: 'Gabriel',
  city: 'San José',
  province: 'CR',
  initial: 'G',
  time: 'hace 15 min',
  pack: 'Pack Completo Listo Para Usar'
}, {
  name: 'Sofía',
  city: 'La Paz',
  province: 'BO',
  initial: 'S',
  time: 'hace 3 horas',
  pack: 'Pack Completo Listo Para Usar'
}, {
  name: 'Marcos',
  city: 'Caracas',
  province: 'VE',
  initial: 'M',
  time: 'hace 7 min',
  pack: 'Pack Completo Listo Para Usar'
}, {
  name: 'Lucía',
  city: 'San Salvador',
  province: 'SV',
  initial: 'L',
  time: 'hace 18 min',
  pack: 'Pack Completo Listo Para Usar'
}, {
  name: 'Pedro',
  city: 'Ciudad de Guatemala',
  province: 'GT',
  initial: 'P',
  time: 'hace 4 min',
  pack: 'Pack Completo Listo Para Usar'
}, {
  name: 'Florencia',
  city: 'Managua',
  province: 'NI',
  initial: 'F',
  time: 'hace 55 min',
  pack: 'Pack Completo Listo Para Usar'
}, {
  name: 'Javier',
  city: 'Tegucigalpa',
  province: 'HN',
  initial: 'J',
  time: 'hace 10 min',
  pack: 'Pack Completo Listo Para Usar'
}, {
  name: 'Camila',
  city: 'San Juan',
  province: 'PR',
  initial: 'C',
  time: 'hace 5 min',
  pack: 'Pack Completo Listo Para Usar'
}, {
  name: 'Martín',
  city: 'Santo Domingo',
  province: 'DO',
  initial: 'M',
  time: 'hace 35 min',
  pack: 'Pack Completo Listo Para Usar'
}, {
  name: 'Valentina',
  city: 'Panamá',
  province: 'PA',
  initial: 'V',
  time: 'hace 1 hora',
  pack: 'Pack Completo Listo Para Usar'
}, {
  name: 'Andrés',
  city: 'Guadalajara',
  province: 'MX',
  initial: 'A',
  time: 'hace 14 min',
  pack: 'Pack Completo Listo Para Usar'
}, {
  name: 'Isabella',
  city: 'Medellín',
  province: 'CO',
  initial: 'I',
  time: 'hace 25 min',
  pack: 'Pack Completo Listo Para Usar'
}];
export function PurchaseToast() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setHasScrolled(true);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    if (!hasScrolled) return;
    const showNext = () => {
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 4000);
      setCurrentIndex(prev => (prev + 1) % buyers.length);
    };
    const interval = setInterval(showNext, 12000);
    const initialTimer = setTimeout(showNext, 2000);
    return () => {
      clearInterval(interval);
      clearTimeout(initialTimer);
    };
  }, [hasScrolled]);
  const currentBuyer = buyers[currentIndex];
  return <AnimatePresence data-id="element-213">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: -50
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -50
    }} className="fixed top-4 left-4 right-4 md:right-auto z-50 bg-white border border-blue-100 p-3 md:p-4 rounded-xl shadow-2xl flex items-center gap-3 md:gap-4 max-w-sm" data-id="element-214">
          <div className="w-10 h-10 md:w-12 md:h-12 bg-emerald-50 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-215">
            <div className="w-8 h-8 md:w-10 md:h-10 bg-emerald-600 rounded-full flex items-center justify-center text-white font-bold text-xs md:text-base" data-id="element-216">
              {currentBuyer.initial}
            </div>
          </div>
          <div className="flex-1" data-id="element-217">
            <div className="flex items-center justify-between" data-id="element-218">
              <p className="text-[11px] md:text-sm font-bold text-slate-900" data-id="element-219">
                {currentBuyer.name} de {currentBuyer.city} (
                {currentBuyer.province}){' '}
                <span className="inline-block w-1.5 h-1.5 md:w-2 md:h-2 bg-green-500 rounded-full ml-1" data-id="element-220"></span>
              </p>
              <button onClick={() => setIsVisible(false)} className="text-slate-400 hover:text-slate-600" data-id="element-221">
                <X size={14} data-id="element-222" />
              </button>
            </div>
            <p className="text-xs text-slate-600" data-id="element-223">
              compró el{' '}
              <span className="text-emerald-600 font-bold" data-id="element-224">
                {currentBuyer.pack}
              </span>
            </p>
            <p className="text-[10px] text-slate-400 mt-1" data-id="element-225">
              {currentBuyer.time}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}